import { Button, Dialog, XIcon } from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { TransformedImage } from "~/components/transformed-image.component";

const EXPERT_REVIEW_SRC = "/images/expert-review.png";

export function ExpertReviewLearnMoreDialog() {
	const { t } = useTranslation(["product", "common"]);

	return (
		<Dialog.Root>
			<Dialog.Trigger asChild>
				<Button
					variant="link"
					size="fit"
					className="text-body-sm"
					data-testid="expert-review-learn-more-link"
				>
					{t("expertReview.learnMore")}
				</Button>
			</Dialog.Trigger>

			<Dialog.Content
				className="bottom-0 md:bottom-auto translate-y-[0%] md:translate-y-[-50%] top-auto md:top-[50%] md:w-[680px] p-0 rounded-t-2xl md:rounded-2xl"
				data-testid="expert-review-learn-more-dialog"
				mobileVariant="fullWidth"
				withCloseButton={false}
			>
				<Dialog.Close className="absolute right-4 top-4 opacity-70 hover:opacity-100 transition-opacity cursor-pointer">
					<XIcon.Raw className="h-6 w-6 text-gray-700" />
					<span className="sr-only">Close</span>
				</Dialog.Close>
				<div className="px-10 pb-10 pt-10 md:px-0 md:pb-0 md:pt-0 flex flex-col gap-4">
					<div className="flex flex-col items-start gap-4">
						<TransformedImage
							src={EXPERT_REVIEW_SRC}
							alt=""
							width={96}
							height={96}
							className="h-24 w-24 shrink-0 object-contain"
							loading="lazy"
						/>
						<Dialog.Title className="text-h5 text-gray-700">
							{t("expertReview.learnMore.title")}
						</Dialog.Title>
					</div>

					<Dialog.Description className="text-body text-gray-700 whitespace-pre-line">
						{t("expertReview.learnMore.content")}
					</Dialog.Description>

					<Dialog.Close asChild>
						<Button
							size="md"
							variant="primary"
							className="w-full"
							data-testid="expert-review-learn-more-close"
						>
							{t("close", { ns: "common" })}
						</Button>
					</Dialog.Close>
				</div>
			</Dialog.Content>
		</Dialog.Root>
	);
}
